import { gql } from '@apollo/client';

export const CURRENCIES_DICTIONARY_QUERY = gql`
  query currenciesDictionary {
    currenciesDictionary {
      id
      code
      name
    }
  }
`;

export const COMMISSION_CALC_TYPES_DICTIONARY_QUERY = gql`
  query commissionCalcTypesDictionary {
    commissionCalcTypesDictionary {
      id
      code
      name
    }
  }
`;

export const SCHEDULE_TYPES_QUERY = gql`
  query scheduleTypes {
    scheduleTypes {
      scheduleTypeId
      scheduleTypeName
    }
  }
`;

export const LEASING_INTEREST_TYPES_QUERY = gql`
  query leasingInterestTypes($currencyId: Int) {
    leasingInterestTypes(currencyId: $currencyId) {
      interestTypeId
      interestTypeName
    }
  }
`;

export const LINK_ITEMS = gql`
  query linkItems($search: String, $retrieveAll: Boolean) {
    linkItems(search: $search, retrieveAll: $retrieveAll) {
      id
      name
    }
  }
`;

export const SUPPLIERS = gql`
  query suppliers($search: String) {
    suppliers(search: $search) {
      id
      name
    }
  }
`;

export const TAX_RATES = gql`
  query taxRateItems {
    taxRateItems {
      id
      name
    }
  }
`;

export const PARTNERS = gql`
  query partners($search: String) {
    partners(search: $search) {
      partnerId
      name
      code
      uniqueId
    }
  }
`;
